import { AriaDatapoint } from './AriaDatapoint';
import { getUserConfiguration } from 'owa-session-store';
import { GenericKeys } from '../types/DatapointEnums';
import { getRefUrl, getFrontend, BootType } from 'owa-config';
import { getPltData } from 'owa-config/lib/bootstrapOptions';

export default class PltDatapoint extends AriaDatapoint {
    constructor(bootType: BootType) {
        super(null, null, { isCore: true });
        // Add additional boot info in addition to GenericKeys for all datapoints
        this.addData(GenericKeys.bootType, bootType);
        this.addData('FEServer', getFrontend());
        this.addData('RefUrl', getRefUrl());

        const data = getPltData();
        if (data) {
            this.addData('pltnav', data.time);
        }

        let userConfiguration = getUserConfiguration();
        if (userConfiguration?.UserOptions) {
            if (userConfiguration.UserOptions.ReactOptinSettings?.MailGraduatedFromBeta) {
                this.addCustomProperty('graduated', '1');
            }

            this.addCustomProperty(
                'optin',
                // ClientTypeOptInState is const numeric enum, we'll convert to string
                '' + userConfiguration.UserOptions.ClientTypeOptInState
            );
        }
    }
    public getEventType(): string {
        return 'Owa_PageLoadTime';
    }
}
